import icon from './icon';
import { jsx as _jsx } from "react/jsx-runtime";
const Icon = icon("-629 392 20 17", "X", /*#__PURE__*/_jsx("path", {
  d: "m-610.6 392.9-.8-.8-7.6 7.7-7.6-7.7-.8.8 7.7 7.6-7.7 7.6.8.8 7.6-7.7 7.6 7.7.8-.8-7.7-7.6z"
}));
if (process.env.NODE_ENV !== 'production') Icon.displayName = "IconX";
export default Icon;